import React from 'react';
import { Tooltip } from 'react-tooltip';
import PrimaryBillActions from './PrimaryBillActions';
import { BillPreviewExtraActions } from './BillPreviewExtraActions';

const BillPreviewActions = ({
  status, billId, paymentReminderOn, isReminderOptionEnabled,
}: {
    status: string,
    billId: string,
    paymentReminderOn: boolean,
    isReminderOptionEnabled: boolean,
}) => (
  <div className='flex justify-between pt-[12px] items-center'>
    <PrimaryBillActions status={status} billId={billId} />
    <BillPreviewExtraActions status={status} billId={billId} paymentReminderOn={paymentReminderOn} isReminderOptionEnabled={isReminderOptionEnabled} />
    <Tooltip id='bill-preview-actions-tooltip' place='bottom' className='text-sm metricR text-bw00 bg-bw08 rounded py-[5px]' />
  </div>
);

export default BillPreviewActions;
